<section class="video-container">
  <iframe [src]="videoLink" width="772" frameborder="0" allowfullscreen></iframe>
  <legend class="body-s">{{ legend }}</legend>
</section>
